import { Instance } from '@Plugin/store';
import { RouteObject } from 'react-router-dom';

export const generateIfPath = (...routes: RouteObject[]) => routes.filter( r=> r.path)

export type RoutesBuilder = (instance: Instance) => RouteObject[];